<template>
  <div class="container">
    <form class="form-horizontal">
      <div class="form-group">
        <label for="inputEmail3" class="text-danger col-xs-1 control-label">角色</label>
        <div class="col-xs-11">
          <template v-for="item in searchConfig.roles" track-by="$index">
            <label class="checkbox-inline">
              <input type="checkbox" v-model="search.abilities" :value="item"> {{item}}
            </label>
            <br v-if="$index == 5">
          </template>
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          标签
        </label>
        <div class="col-xs-11">
          <label class="checkbox-inline" v-for="item in searchConfig.tags" track-by="$index">
            <input type="checkbox" v-model="search.abilities" :value="item"> {{item}}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          状态
        </label>
        <div class="col-xs-11">
          <label class="checkbox-inline" v-for="(key, val) in searchConfig.statusMap" track-by="$index">
            <input type="checkbox" v-model="search.status" :value="key"> {{val}}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          路线
        </label>
        <div class="col-xs-3">
          <input type="text" class="form-control" v-model="search.routeName">
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          昵称
        </label>
        <div class="col-xs-3">
          <input type="text" class="form-control" v-model="search.name">
        </div>
      </div>
      <div class="form-group">
        <div class="col-xs-offset-1 col-xs-3">
          <div class="row">
            <div class="col-xs-6">
              <button type="reset" class="btn btn-block btn-default pull-right">reset</button>
            </div>
            <div class="col-xs-6">
              <button type="button" class="btn btn-block btn-primary" @click="click(queryList)($event)">搜索</button>
            </div>
          </div>
        </div>
        <div class="col-xs-8">
          <a class="btn btn-danger pull-right" v-link="'/giver'">添加新领队</a>
        </div>
      </div>
    </form>
    <tabset>
      <tab header="正式队员">
        <div class="row row-giver">
          <div class="col-xs-3" v-for="item in list" track-by="$index" v-if="item.status != 5">
            <div class="panel panel-default">
              <div class="panel-heading">
                <span class="text-success">
                  {{item.name}}({{item.nickName}})
                </span>
                <span class="text-warning">
                  {{item.sex}}
                  {{item.mobile}}
                </span>
                <a class="pull-right" href="/giver/{{item.id}}" target="_blank">管理</a>
              </div>
              <div class="panel-body">
                地址：{{item.province}}{{item.city}}{{item.county}}{{item.address}}
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab header="退出队员">
        <div class="row row-giver">
          <div class="col-xs-3" v-for="item in list" track-by="$index" v-if="item.status == 5">
            <div class="panel panel-default">
              <div class="panel-heading">
                <span class="text-success">
                  {{item.name}}({{item.nickName}})
                </span>
                <span class="text-warning">
                  {{item.sex}}
                  {{item.mobile}}
                </span>
                <a class="pull-right" href="/giver/{{item.id}}" target="_blank">管理</a>
              </div>
              <div class="panel-body">
                地址：{{item.province}}{{item.city}}{{item.county}}{{item.address}}
              </div>
            </div>
          </div>
        </div>
      </tab>
    </tabset>
  </div>
</template>

<script>
  import { tabset, tab } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import _ from 'lodash'

  let searchConfig = _.cloneDeep(config.givers)
  delete searchConfig.statusMap[5]

  export default {
    data () {
      return {
        searchConfig,
        list: [],
        search: {
          abilities: [],
          status: [],
          routeName: '',
          name: ''
        }
      }
    },
    components: {
      tabset,
      tab
    },
    methods: {
      queryList ($event) {
        let params = {}
        Object.keys(this.search).forEach((key) => {
          if (Array.isArray(this.search[key])) {
            params[key] = this.search[key].join(',')
          } else {
            params[key] = this.search[key]
          }

          if (!params[key]) {
            delete params[key]
          }
        })
        return this.$http.get(config.api + '/giver/leader', params)
          .then(function ({data}) {
            this.list = data
          })
      },
      click: utils.click
    },
    route: {
      data () {
        return this.queryList()
      }
    }
  }
</script>

<style scoped>
  .row-giver {
    display: flex;
    flex-wrap: wrap;
  }
</style>



/** WEBPACK FOOTER **
 ** List.vue?22d0206e
 **/